import addMount from "../../core/addMount";
import SearchHeaderEntry from "./search-header.entry";

addMount({ appName: "search-header", app: SearchHeaderEntry });
